// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "teleop/v1/teleop.proto" (package "teleop.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
//
// Internal apis for the teleop workspace service
//
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Empty } from "../../google/protobuf/empty";
import { Timestamp } from "../../google/protobuf/timestamp";
/**
 * @generated from protobuf message teleop.v1.CreateWorkspaceRequest
 */
export interface CreateWorkspaceRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message teleop.v1.CreateWorkspaceResponse
 */
export interface CreateWorkspaceResponse {
    /**
     * @generated from protobuf field: string workspace_id = 1;
     */
    workspaceId: string;
}
/**
 * @generated from protobuf message teleop.v1.GetWorkspaceRequest
 */
export interface GetWorkspaceRequest {
    /**
     * @generated from protobuf field: string workspace_id = 1;
     */
    workspaceId: string;
}
/**
 * @generated from protobuf message teleop.v1.GetWorkspaceResponse
 */
export interface GetWorkspaceResponse {
    /**
     * @generated from protobuf field: teleop.v1.Workspace workspace = 1;
     */
    workspace?: Workspace;
}
/**
 * @generated from protobuf message teleop.v1.ListWorkspacesRequest
 */
export interface ListWorkspacesRequest {
    /**
     * @generated from protobuf field: string org_id = 1;
     */
    orgId: string;
}
/**
 * @generated from protobuf message teleop.v1.ListWorkspacesSummary
 */
export interface ListWorkspacesSummary {
    /**
     * @generated from protobuf field: string workspace_id = 1;
     */
    workspaceId: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_updated_at = 4;
     */
    lastUpdatedAt?: Timestamp;
}
/**
 * @generated from protobuf message teleop.v1.ListWorkspacesResponse
 */
export interface ListWorkspacesResponse {
    /**
     * sorted by oldest created workspace -> most recently created workspace
     *
     * @generated from protobuf field: repeated teleop.v1.ListWorkspacesSummary workspaces = 1;
     */
    workspaces: ListWorkspacesSummary[];
}
/**
 * @generated from protobuf message teleop.v1.DuplicateWorkspaceRequest
 */
export interface DuplicateWorkspaceRequest {
    /**
     * @generated from protobuf field: string workspace_id = 1;
     */
    workspaceId: string;
}
/**
 * @generated from protobuf message teleop.v1.DuplicateWorkspaceResponse
 */
export interface DuplicateWorkspaceResponse {
    /**
     * @generated from protobuf field: string new_workspace_id = 1;
     */
    newWorkspaceId: string;
}
/**
 * @generated from protobuf message teleop.v1.DeleteWorkspaceRequest
 */
export interface DeleteWorkspaceRequest {
    /**
     * @generated from protobuf field: string workspace_id = 1;
     */
    workspaceId: string;
}
/**
 * @generated from protobuf message teleop.v1.DeleteWorkspaceResponse
 */
export interface DeleteWorkspaceResponse {
}
/**
 * @generated from protobuf message teleop.v1.UpdateWorkspaceLayoutRequest
 */
export interface UpdateWorkspaceLayoutRequest {
    /**
     * @generated from protobuf field: string workspace_id = 1;
     */
    workspaceId: string;
    /**
     * @generated from protobuf field: teleop.v1.WorkspaceNode new_layout_root = 2;
     */
    newLayoutRoot?: WorkspaceNode;
}
/**
 * @generated from protobuf message teleop.v1.UpdateWorkspaceLayoutResponse
 */
export interface UpdateWorkspaceLayoutResponse {
}
/**
 * @generated from protobuf message teleop.v1.UpdateWorkspaceNameRequest
 */
export interface UpdateWorkspaceNameRequest {
    /**
     * @generated from protobuf field: string workspace_id = 1;
     */
    workspaceId: string;
    /**
     * @generated from protobuf field: string new_name = 2;
     */
    newName: string;
}
/**
 * @generated from protobuf message teleop.v1.UpdateWorkspaceNameResponse
 */
export interface UpdateWorkspaceNameResponse {
}
/**
 * @generated from protobuf message teleop.v1.SplitNode
 */
export interface SplitNode {
    /**
     * @generated from protobuf field: teleop.v1.SplitDirection direction = 1;
     */
    direction: SplitDirection;
    /**
     * In the non-inclusive range (0, 1). Missing indicates 0.5 (or 50%) split.
     *
     * @generated from protobuf field: double split_percentage = 2;
     */
    splitPercentage: number;
    /**
     * @generated from protobuf field: teleop.v1.WorkspaceNode first = 3;
     */
    first?: WorkspaceNode;
    /**
     * @generated from protobuf field: teleop.v1.WorkspaceNode second = 4;
     */
    second?: WorkspaceNode;
}
/**
 * @generated from protobuf message teleop.v1.SensorStatNode
 */
export interface SensorStatNode {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: string sensor_name = 2;
     */
    sensorName: string;
    /**
     * @generated from protobuf field: double refetch_interval_s = 3;
     */
    refetchIntervalS: number;
    /**
     * @generated from protobuf field: string path = 4;
     */
    path: string;
    /**
     * @generated from protobuf field: string units = 5;
     */
    units: string;
}
/**
 * @generated from protobuf message teleop.v1.CameraNode
 */
export interface CameraNode {
    /**
     * @generated from protobuf field: string camera_name = 1;
     */
    cameraName: string;
    /**
     * @generated from protobuf oneof: refetch_interval
     */
    refetchInterval: {
        oneofKind: "seconds";
        /**
         * @generated from protobuf field: double seconds = 2;
         */
        seconds: number;
    } | {
        oneofKind: "live";
        /**
         * @generated from protobuf field: google.protobuf.Empty live = 3;
         */
        live: Empty;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message teleop.v1.TimeSeriesNode
 */
export interface TimeSeriesNode {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: double relative_time_range_min = 3;
     */
    relativeTimeRangeMin: number;
    /**
     * @generated from protobuf field: optional double y_axis_min = 5;
     */
    yAxisMin?: number;
    /**
     * @generated from protobuf field: optional double y_axis_max = 6;
     */
    yAxisMax?: number;
    /**
     * @generated from protobuf field: repeated teleop.v1.TimeSeriesLine lines = 4;
     */
    lines: TimeSeriesLine[];
    /**
     * @generated from protobuf field: double refetch_interval_s = 7;
     */
    refetchIntervalS: number;
}
/**
 * @generated from protobuf message teleop.v1.TimeSeriesLine
 */
export interface TimeSeriesLine {
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf field: string units = 2;
     */
    units: string;
    /**
     * @generated from protobuf field: string resource_name = 9;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: string capture_method = 10;
     */
    captureMethod: string;
    /**
     * @generated from protobuf oneof: method
     */
    method: {
        oneofKind: "noAggregation";
        /**
         * @generated from protobuf field: teleop.v1.TimeSeriesMethodNoAggregation no_aggregation = 3;
         */
        noAggregation: TimeSeriesMethodNoAggregation;
    } | {
        oneofKind: "count";
        /**
         * @generated from protobuf field: teleop.v1.TimeSeriesMethodCount count = 4;
         */
        count: TimeSeriesMethodCount;
    } | {
        oneofKind: "average";
        /**
         * @generated from protobuf field: teleop.v1.TimeSeriesMethodAvg average = 5;
         */
        average: TimeSeriesMethodAvg;
    } | {
        oneofKind: "min";
        /**
         * @generated from protobuf field: teleop.v1.TimeSeriesMethodMin min = 6;
         */
        min: TimeSeriesMethodMin;
    } | {
        oneofKind: "max";
        /**
         * @generated from protobuf field: teleop.v1.TimeSeriesMethodMax max = 7;
         */
        max: TimeSeriesMethodMax;
    } | {
        oneofKind: "customQuery";
        /**
         * @generated from protobuf field: teleop.v1.TimeSeriesMethodCustomQuery custom_query = 8;
         */
        customQuery: TimeSeriesMethodCustomQuery;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message teleop.v1.TimeSeriesMethodNoAggregation
 */
export interface TimeSeriesMethodNoAggregation {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
}
/**
 * @generated from protobuf message teleop.v1.TimeSeriesMethodCount
 */
export interface TimeSeriesMethodCount {
    /**
     * @generated from protobuf field: double duration_s = 1;
     */
    durationS: number;
}
/**
 * @generated from protobuf message teleop.v1.TimeSeriesMethodAvg
 */
export interface TimeSeriesMethodAvg {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: double duration_s = 2;
     */
    durationS: number;
}
/**
 * @generated from protobuf message teleop.v1.TimeSeriesMethodMin
 */
export interface TimeSeriesMethodMin {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: double duration_s = 2;
     */
    durationS: number;
}
/**
 * @generated from protobuf message teleop.v1.TimeSeriesMethodMax
 */
export interface TimeSeriesMethodMax {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: double duration_s = 2;
     */
    durationS: number;
}
/**
 * @generated from protobuf message teleop.v1.TimeSeriesMethodCustomQuery
 */
export interface TimeSeriesMethodCustomQuery {
    /**
     * @generated from protobuf field: repeated string stages = 1;
     */
    stages: string[];
}
/**
 * @generated from protobuf message teleop.v1.ActuationNode
 */
export interface ActuationNode {
    /**
     * @generated from protobuf field: string resource_name = 1;
     */
    resourceName: string;
    /**
     * @generated from protobuf oneof: actuation
     */
    actuation: {
        oneofKind: "arm";
        /**
         * @generated from protobuf field: teleop.v1.ArmActuation arm = 2;
         */
        arm: ArmActuation;
    } | {
        oneofKind: "base";
        /**
         * @generated from protobuf field: teleop.v1.BaseActuation base = 3;
         */
        base: BaseActuation;
    } | {
        oneofKind: "board";
        /**
         * @generated from protobuf field: teleop.v1.BoardActuation board = 4;
         */
        board: BoardActuation;
    } | {
        oneofKind: "gantry";
        /**
         * @generated from protobuf field: teleop.v1.GantryActuation gantry = 5;
         */
        gantry: GantryActuation;
    } | {
        oneofKind: "gripper";
        /**
         * @generated from protobuf field: teleop.v1.GripperActuation gripper = 6;
         */
        gripper: GripperActuation;
    } | {
        oneofKind: "motor";
        /**
         * @generated from protobuf field: teleop.v1.MotorActuation motor = 7;
         */
        motor: MotorActuation;
    } | {
        oneofKind: "servo";
        /**
         * @generated from protobuf field: teleop.v1.ServoActuation servo = 8;
         */
        servo: ServoActuation;
    } | {
        oneofKind: "button";
        /**
         * @generated from protobuf field: teleop.v1.ButtonActuation button = 9;
         */
        button: ButtonActuation;
    } | {
        oneofKind: "switch";
        /**
         * @generated from protobuf field: teleop.v1.SwitchActuation switch = 10;
         */
        switch: SwitchActuation;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message teleop.v1.GPSNode
 */
export interface GPSNode {
    /**
     * @generated from protobuf field: string movement_sensor_name = 1;
     */
    movementSensorName: string;
    /**
     * @generated from protobuf field: double refetch_interval_s = 2;
     */
    refetchIntervalS: number;
    /**
     * @generated from protobuf field: double relative_time_range_min = 3;
     */
    relativeTimeRangeMin: number;
}
/**
 * @generated from protobuf message teleop.v1.TableNode
 */
export interface TableNode {
    /**
     * @generated from protobuf field: string capture_method = 5;
     */
    captureMethod: string;
    /**
     * @generated from protobuf field: double refetch_interval_s = 3;
     */
    refetchIntervalS: number;
    /**
     * @generated from protobuf field: double relative_time_range_min = 4;
     */
    relativeTimeRangeMin: number;
    /**
     * @generated from protobuf field: string resource_name = 2;
     */
    resourceName: string;
    /**
     * @generated from protobuf field: string title = 1;
     */
    title: string;
    /**
     * @generated from protobuf oneof: method
     */
    method: {
        oneofKind: "customQuery";
        /**
         * @generated from protobuf field: teleop.v1.TableMethodCustomQuery custom_query = 6;
         */
        customQuery: TableMethodCustomQuery;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message teleop.v1.TableMethodCustomQuery
 */
export interface TableMethodCustomQuery {
    /**
     * @generated from protobuf field: repeated string stages = 1;
     */
    stages: string[];
}
/**
 * @generated from protobuf message teleop.v1.WorkspaceNode
 */
export interface WorkspaceNode {
    /**
     * @generated from protobuf field: string node_id = 1;
     */
    nodeId: string;
    /**
     * @generated from protobuf oneof: node
     */
    node: {
        oneofKind: "split";
        /**
         * @generated from protobuf field: teleop.v1.SplitNode split = 2;
         */
        split: SplitNode;
    } | {
        oneofKind: "stat";
        /**
         * @generated from protobuf field: teleop.v1.SensorStatNode stat = 3;
         */
        stat: SensorStatNode;
    } | {
        oneofKind: "camera";
        /**
         * @generated from protobuf field: teleop.v1.CameraNode camera = 4;
         */
        camera: CameraNode;
    } | {
        oneofKind: "timeSeries";
        /**
         * @generated from protobuf field: teleop.v1.TimeSeriesNode time_series = 5;
         */
        timeSeries: TimeSeriesNode;
    } | {
        oneofKind: "actuation";
        /**
         * @generated from protobuf field: teleop.v1.ActuationNode actuation = 6;
         */
        actuation: ActuationNode;
    } | {
        oneofKind: "gps";
        /**
         * @generated from protobuf field: teleop.v1.GPSNode gps = 7;
         */
        gps: GPSNode;
    } | {
        oneofKind: "table";
        /**
         * @generated from protobuf field: teleop.v1.TableNode table = 8;
         */
        table: TableNode;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message teleop.v1.Workspace
 */
export interface Workspace {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string name = 2;
     */
    name: string;
    /**
     * @generated from protobuf field: string org_id = 3;
     */
    orgId: string;
    /**
     * @generated from protobuf field: optional teleop.v1.WorkspaceNode layout_root = 4;
     */
    layoutRoot?: WorkspaceNode;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_updated_at = 6;
     */
    lastUpdatedAt?: Timestamp;
}
/**
 * @generated from protobuf enum teleop.v1.SplitDirection
 */
export enum SplitDirection {
    /**
     * @generated from protobuf enum value: SPLIT_DIRECTION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SPLIT_DIRECTION_COLUMN = 1;
     */
    COLUMN = 1,
    /**
     * @generated from protobuf enum value: SPLIT_DIRECTION_ROW = 2;
     */
    ROW = 2
}
/**
 * @generated from protobuf enum teleop.v1.ArmActuation
 */
export enum ArmActuation {
    /**
     * @generated from protobuf enum value: ARM_ACTUATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ARM_ACTUATION_MOVE_TO_JOINT_POSITIONS = 1;
     */
    MOVE_TO_JOINT_POSITIONS = 1,
    /**
     * @generated from protobuf enum value: ARM_ACTUATION_MOVE_TO_POSITION = 4;
     */
    MOVE_TO_POSITION = 4,
    /**
     * @generated from protobuf enum value: ARM_ACTUATION_QUICK_MOVE = 2;
     */
    QUICK_MOVE = 2,
    /**
     * @generated from protobuf enum value: ARM_ACTUATION_STOP = 3;
     */
    STOP = 3
}
/**
 * @generated from protobuf enum teleop.v1.BaseActuation
 */
export enum BaseActuation {
    /**
     * @generated from protobuf enum value: BASE_ACTUATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: BASE_ACTUATION_MOVE_STRAIGHT = 1;
     */
    MOVE_STRAIGHT = 1,
    /**
     * @generated from protobuf enum value: BASE_ACTUATION_QUICK_MOVE = 2;
     */
    QUICK_MOVE = 2,
    /**
     * @generated from protobuf enum value: BASE_ACTUATION_SET_POWER = 3;
     */
    SET_POWER = 3,
    /**
     * @generated from protobuf enum value: BASE_ACTUATION_SET_VELOCITY = 4;
     */
    SET_VELOCITY = 4,
    /**
     * @generated from protobuf enum value: BASE_ACTUATION_SPIN = 5;
     */
    SPIN = 5,
    /**
     * @generated from protobuf enum value: BASE_ACTUATION_STOP = 6;
     */
    STOP = 6
}
/**
 * @generated from protobuf enum teleop.v1.BoardActuation
 */
export enum BoardActuation {
    /**
     * @generated from protobuf enum value: BOARD_ACTUATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: BOARD_ACTUATION_READ_AND_WRITE_PINS = 1;
     */
    READ_AND_WRITE_PINS = 1
}
/**
 * @generated from protobuf enum teleop.v1.ButtonActuation
 */
export enum ButtonActuation {
    /**
     * @generated from protobuf enum value: BUTTON_ACTUATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: BUTTON_ACTUATION_PUSH = 1;
     */
    PUSH = 1
}
/**
 * @generated from protobuf enum teleop.v1.GantryActuation
 */
export enum GantryActuation {
    /**
     * @generated from protobuf enum value: GANTRY_ACTUATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GANTRY_ACTUATION_HOME = 1;
     */
    HOME = 1,
    /**
     * @generated from protobuf enum value: GANTRY_ACTUATION_MOVE_TO_POSITION = 2;
     */
    MOVE_TO_POSITION = 2,
    /**
     * @generated from protobuf enum value: GANTRY_ACTUATION_QUICK_MOVE = 3;
     */
    QUICK_MOVE = 3,
    /**
     * @generated from protobuf enum value: GANTRY_ACTUATION_STOP = 4;
     */
    STOP = 4
}
/**
 * @generated from protobuf enum teleop.v1.GripperActuation
 */
export enum GripperActuation {
    /**
     * @generated from protobuf enum value: GRIPPER_ACTUATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRIPPER_ACTUATION_OPEN_GRAB = 1;
     */
    OPEN_GRAB = 1,
    /**
     * @generated from protobuf enum value: GRIPPER_ACTUATION_STOP = 2;
     */
    STOP = 2
}
/**
 * @generated from protobuf enum teleop.v1.MotorActuation
 */
export enum MotorActuation {
    /**
     * @generated from protobuf enum value: MOTOR_ACTUATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: MOTOR_ACTUATION_GO_FOR = 1;
     */
    GO_FOR = 1,
    /**
     * @generated from protobuf enum value: MOTOR_ACTUATION_GO_TO = 2;
     */
    GO_TO = 2,
    /**
     * @generated from protobuf enum value: MOTOR_ACTUATION_QUICK_MOVE = 3;
     */
    QUICK_MOVE = 3,
    /**
     * @generated from protobuf enum value: MOTOR_ACTUATION_SET_POWER = 4;
     */
    SET_POWER = 4,
    /**
     * @generated from protobuf enum value: MOTOR_ACTUATION_SET_RPM = 6;
     */
    SET_RPM = 6,
    /**
     * @generated from protobuf enum value: MOTOR_ACTUATION_STOP = 5;
     */
    STOP = 5
}
/**
 * @generated from protobuf enum teleop.v1.ServoActuation
 */
export enum ServoActuation {
    /**
     * @generated from protobuf enum value: SERVO_ACTUATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SERVO_ACTUATION_MOVE = 1;
     */
    MOVE = 1,
    /**
     * @generated from protobuf enum value: SERVO_ACTUATION_QUICK_MOVE = 2;
     */
    QUICK_MOVE = 2,
    /**
     * @generated from protobuf enum value: SERVO_ACTUATION_STOP = 3;
     */
    STOP = 3
}
/**
 * @generated from protobuf enum teleop.v1.SwitchActuation
 */
export enum SwitchActuation {
    /**
     * @generated from protobuf enum value: SWITCH_ACTUATION_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: SWITCH_ACTUATION_POSITION = 1;
     */
    POSITION = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class CreateWorkspaceRequest$Type extends MessageType<CreateWorkspaceRequest> {
    constructor() {
        super("teleop.v1.CreateWorkspaceRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.CreateWorkspaceRequest
 */
export const CreateWorkspaceRequest = new CreateWorkspaceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateWorkspaceResponse$Type extends MessageType<CreateWorkspaceResponse> {
    constructor() {
        super("teleop.v1.CreateWorkspaceResponse", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.CreateWorkspaceResponse
 */
export const CreateWorkspaceResponse = new CreateWorkspaceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWorkspaceRequest$Type extends MessageType<GetWorkspaceRequest> {
    constructor() {
        super("teleop.v1.GetWorkspaceRequest", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.GetWorkspaceRequest
 */
export const GetWorkspaceRequest = new GetWorkspaceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetWorkspaceResponse$Type extends MessageType<GetWorkspaceResponse> {
    constructor() {
        super("teleop.v1.GetWorkspaceResponse", [
            { no: 1, name: "workspace", kind: "message", T: () => Workspace }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.GetWorkspaceResponse
 */
export const GetWorkspaceResponse = new GetWorkspaceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListWorkspacesRequest$Type extends MessageType<ListWorkspacesRequest> {
    constructor() {
        super("teleop.v1.ListWorkspacesRequest", [
            { no: 1, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.ListWorkspacesRequest
 */
export const ListWorkspacesRequest = new ListWorkspacesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListWorkspacesSummary$Type extends MessageType<ListWorkspacesSummary> {
    constructor() {
        super("teleop.v1.ListWorkspacesSummary", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "last_updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.ListWorkspacesSummary
 */
export const ListWorkspacesSummary = new ListWorkspacesSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListWorkspacesResponse$Type extends MessageType<ListWorkspacesResponse> {
    constructor() {
        super("teleop.v1.ListWorkspacesResponse", [
            { no: 1, name: "workspaces", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ListWorkspacesSummary }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.ListWorkspacesResponse
 */
export const ListWorkspacesResponse = new ListWorkspacesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DuplicateWorkspaceRequest$Type extends MessageType<DuplicateWorkspaceRequest> {
    constructor() {
        super("teleop.v1.DuplicateWorkspaceRequest", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.DuplicateWorkspaceRequest
 */
export const DuplicateWorkspaceRequest = new DuplicateWorkspaceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DuplicateWorkspaceResponse$Type extends MessageType<DuplicateWorkspaceResponse> {
    constructor() {
        super("teleop.v1.DuplicateWorkspaceResponse", [
            { no: 1, name: "new_workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.DuplicateWorkspaceResponse
 */
export const DuplicateWorkspaceResponse = new DuplicateWorkspaceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteWorkspaceRequest$Type extends MessageType<DeleteWorkspaceRequest> {
    constructor() {
        super("teleop.v1.DeleteWorkspaceRequest", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.DeleteWorkspaceRequest
 */
export const DeleteWorkspaceRequest = new DeleteWorkspaceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteWorkspaceResponse$Type extends MessageType<DeleteWorkspaceResponse> {
    constructor() {
        super("teleop.v1.DeleteWorkspaceResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.DeleteWorkspaceResponse
 */
export const DeleteWorkspaceResponse = new DeleteWorkspaceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateWorkspaceLayoutRequest$Type extends MessageType<UpdateWorkspaceLayoutRequest> {
    constructor() {
        super("teleop.v1.UpdateWorkspaceLayoutRequest", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_layout_root", kind: "message", T: () => WorkspaceNode }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.UpdateWorkspaceLayoutRequest
 */
export const UpdateWorkspaceLayoutRequest = new UpdateWorkspaceLayoutRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateWorkspaceLayoutResponse$Type extends MessageType<UpdateWorkspaceLayoutResponse> {
    constructor() {
        super("teleop.v1.UpdateWorkspaceLayoutResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.UpdateWorkspaceLayoutResponse
 */
export const UpdateWorkspaceLayoutResponse = new UpdateWorkspaceLayoutResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateWorkspaceNameRequest$Type extends MessageType<UpdateWorkspaceNameRequest> {
    constructor() {
        super("teleop.v1.UpdateWorkspaceNameRequest", [
            { no: 1, name: "workspace_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "new_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.UpdateWorkspaceNameRequest
 */
export const UpdateWorkspaceNameRequest = new UpdateWorkspaceNameRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateWorkspaceNameResponse$Type extends MessageType<UpdateWorkspaceNameResponse> {
    constructor() {
        super("teleop.v1.UpdateWorkspaceNameResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.UpdateWorkspaceNameResponse
 */
export const UpdateWorkspaceNameResponse = new UpdateWorkspaceNameResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SplitNode$Type extends MessageType<SplitNode> {
    constructor() {
        super("teleop.v1.SplitNode", [
            { no: 1, name: "direction", kind: "enum", T: () => ["teleop.v1.SplitDirection", SplitDirection, "SPLIT_DIRECTION_"] },
            { no: 2, name: "split_percentage", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "first", kind: "message", T: () => WorkspaceNode },
            { no: 4, name: "second", kind: "message", T: () => WorkspaceNode }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.SplitNode
 */
export const SplitNode = new SplitNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SensorStatNode$Type extends MessageType<SensorStatNode> {
    constructor() {
        super("teleop.v1.SensorStatNode", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "sensor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "refetch_interval_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "units", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.SensorStatNode
 */
export const SensorStatNode = new SensorStatNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CameraNode$Type extends MessageType<CameraNode> {
    constructor() {
        super("teleop.v1.CameraNode", [
            { no: 1, name: "camera_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "seconds", kind: "scalar", oneof: "refetchInterval", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "live", kind: "message", oneof: "refetchInterval", T: () => Empty }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.CameraNode
 */
export const CameraNode = new CameraNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesNode$Type extends MessageType<TimeSeriesNode> {
    constructor() {
        super("teleop.v1.TimeSeriesNode", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "relative_time_range_min", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "y_axis_min", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "y_axis_max", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimeSeriesLine },
            { no: 7, name: "refetch_interval_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.TimeSeriesNode
 */
export const TimeSeriesNode = new TimeSeriesNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesLine$Type extends MessageType<TimeSeriesLine> {
    constructor() {
        super("teleop.v1.TimeSeriesLine", [
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "units", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "capture_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "no_aggregation", kind: "message", oneof: "method", T: () => TimeSeriesMethodNoAggregation },
            { no: 4, name: "count", kind: "message", oneof: "method", T: () => TimeSeriesMethodCount },
            { no: 5, name: "average", kind: "message", oneof: "method", T: () => TimeSeriesMethodAvg },
            { no: 6, name: "min", kind: "message", oneof: "method", T: () => TimeSeriesMethodMin },
            { no: 7, name: "max", kind: "message", oneof: "method", T: () => TimeSeriesMethodMax },
            { no: 8, name: "custom_query", kind: "message", oneof: "method", T: () => TimeSeriesMethodCustomQuery }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.TimeSeriesLine
 */
export const TimeSeriesLine = new TimeSeriesLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesMethodNoAggregation$Type extends MessageType<TimeSeriesMethodNoAggregation> {
    constructor() {
        super("teleop.v1.TimeSeriesMethodNoAggregation", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.TimeSeriesMethodNoAggregation
 */
export const TimeSeriesMethodNoAggregation = new TimeSeriesMethodNoAggregation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesMethodCount$Type extends MessageType<TimeSeriesMethodCount> {
    constructor() {
        super("teleop.v1.TimeSeriesMethodCount", [
            { no: 1, name: "duration_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.TimeSeriesMethodCount
 */
export const TimeSeriesMethodCount = new TimeSeriesMethodCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesMethodAvg$Type extends MessageType<TimeSeriesMethodAvg> {
    constructor() {
        super("teleop.v1.TimeSeriesMethodAvg", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "duration_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.TimeSeriesMethodAvg
 */
export const TimeSeriesMethodAvg = new TimeSeriesMethodAvg$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesMethodMin$Type extends MessageType<TimeSeriesMethodMin> {
    constructor() {
        super("teleop.v1.TimeSeriesMethodMin", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "duration_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.TimeSeriesMethodMin
 */
export const TimeSeriesMethodMin = new TimeSeriesMethodMin$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesMethodMax$Type extends MessageType<TimeSeriesMethodMax> {
    constructor() {
        super("teleop.v1.TimeSeriesMethodMax", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "duration_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.TimeSeriesMethodMax
 */
export const TimeSeriesMethodMax = new TimeSeriesMethodMax$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeSeriesMethodCustomQuery$Type extends MessageType<TimeSeriesMethodCustomQuery> {
    constructor() {
        super("teleop.v1.TimeSeriesMethodCustomQuery", [
            { no: 1, name: "stages", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.TimeSeriesMethodCustomQuery
 */
export const TimeSeriesMethodCustomQuery = new TimeSeriesMethodCustomQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ActuationNode$Type extends MessageType<ActuationNode> {
    constructor() {
        super("teleop.v1.ActuationNode", [
            { no: 1, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "arm", kind: "enum", oneof: "actuation", T: () => ["teleop.v1.ArmActuation", ArmActuation, "ARM_ACTUATION_"] },
            { no: 3, name: "base", kind: "enum", oneof: "actuation", T: () => ["teleop.v1.BaseActuation", BaseActuation, "BASE_ACTUATION_"] },
            { no: 4, name: "board", kind: "enum", oneof: "actuation", T: () => ["teleop.v1.BoardActuation", BoardActuation, "BOARD_ACTUATION_"] },
            { no: 5, name: "gantry", kind: "enum", oneof: "actuation", T: () => ["teleop.v1.GantryActuation", GantryActuation, "GANTRY_ACTUATION_"] },
            { no: 6, name: "gripper", kind: "enum", oneof: "actuation", T: () => ["teleop.v1.GripperActuation", GripperActuation, "GRIPPER_ACTUATION_"] },
            { no: 7, name: "motor", kind: "enum", oneof: "actuation", T: () => ["teleop.v1.MotorActuation", MotorActuation, "MOTOR_ACTUATION_"] },
            { no: 8, name: "servo", kind: "enum", oneof: "actuation", T: () => ["teleop.v1.ServoActuation", ServoActuation, "SERVO_ACTUATION_"] },
            { no: 9, name: "button", kind: "enum", oneof: "actuation", T: () => ["teleop.v1.ButtonActuation", ButtonActuation, "BUTTON_ACTUATION_"] },
            { no: 10, name: "switch", kind: "enum", oneof: "actuation", T: () => ["teleop.v1.SwitchActuation", SwitchActuation, "SWITCH_ACTUATION_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.ActuationNode
 */
export const ActuationNode = new ActuationNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GPSNode$Type extends MessageType<GPSNode> {
    constructor() {
        super("teleop.v1.GPSNode", [
            { no: 1, name: "movement_sensor_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "refetch_interval_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "relative_time_range_min", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.GPSNode
 */
export const GPSNode = new GPSNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TableNode$Type extends MessageType<TableNode> {
    constructor() {
        super("teleop.v1.TableNode", [
            { no: 5, name: "capture_method", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "refetch_interval_s", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "relative_time_range_min", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "resource_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 1, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "custom_query", kind: "message", oneof: "method", T: () => TableMethodCustomQuery }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.TableNode
 */
export const TableNode = new TableNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TableMethodCustomQuery$Type extends MessageType<TableMethodCustomQuery> {
    constructor() {
        super("teleop.v1.TableMethodCustomQuery", [
            { no: 1, name: "stages", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.TableMethodCustomQuery
 */
export const TableMethodCustomQuery = new TableMethodCustomQuery$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WorkspaceNode$Type extends MessageType<WorkspaceNode> {
    constructor() {
        super("teleop.v1.WorkspaceNode", [
            { no: 1, name: "node_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "split", kind: "message", oneof: "node", T: () => SplitNode },
            { no: 3, name: "stat", kind: "message", oneof: "node", T: () => SensorStatNode },
            { no: 4, name: "camera", kind: "message", oneof: "node", T: () => CameraNode },
            { no: 5, name: "time_series", kind: "message", oneof: "node", T: () => TimeSeriesNode },
            { no: 6, name: "actuation", kind: "message", oneof: "node", T: () => ActuationNode },
            { no: 7, name: "gps", kind: "message", oneof: "node", T: () => GPSNode },
            { no: 8, name: "table", kind: "message", oneof: "node", T: () => TableNode }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.WorkspaceNode
 */
export const WorkspaceNode = new WorkspaceNode$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Workspace$Type extends MessageType<Workspace> {
    constructor() {
        super("teleop.v1.Workspace", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "layout_root", kind: "message", T: () => WorkspaceNode },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "last_updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message teleop.v1.Workspace
 */
export const Workspace = new Workspace$Type();
/**
 * @generated ServiceType for protobuf service teleop.v1.TeleopService
 */
export const TeleopService = new ServiceType("teleop.v1.TeleopService", [
    { name: "CreateWorkspace", options: {}, I: CreateWorkspaceRequest, O: CreateWorkspaceResponse },
    { name: "GetWorkspace", options: {}, I: GetWorkspaceRequest, O: GetWorkspaceResponse },
    { name: "ListWorkspaces", options: {}, I: ListWorkspacesRequest, O: ListWorkspacesResponse },
    { name: "DuplicateWorkspace", options: {}, I: DuplicateWorkspaceRequest, O: DuplicateWorkspaceResponse },
    { name: "DeleteWorkspace", options: {}, I: DeleteWorkspaceRequest, O: DeleteWorkspaceResponse },
    { name: "UpdateWorkspaceLayout", options: {}, I: UpdateWorkspaceLayoutRequest, O: UpdateWorkspaceLayoutResponse },
    { name: "UpdateWorkspaceName", options: {}, I: UpdateWorkspaceNameRequest, O: UpdateWorkspaceNameResponse }
]);
